import {CONTACT_START, CONTACT_SUCCESS, CONTACT_FAIL, CONTACT_RESET} from './constants';
import {ContactActions, ContactState} from './types';

const initialState: ContactState = {
  loading: false,
  data: undefined,
  error: undefined,
};

const reducer = (
  state = initialState,
  action: ContactActions,
): ContactState => {
  switch (action.type) {
    case CONTACT_START:
      return {
        ...initialState,
        loading: true,
      };
    case CONTACT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case CONTACT_FAIL:
     return {
        ...state,
        loading: false,
        error: action.error,
      };
    case CONTACT_RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducer;
